// extracted by mini-css-extract-plugin
export var clutchIcon = "SocialMediaIcon-module--clutchIcon--7ac77";
export var icon = "SocialMediaIcon-module--icon--de9b5";
export var link = "SocialMediaIcon-module--link--3bf5e";